import { IBar, IScore } from "../../../../common/types";
import getLastBar from "./getLastBar";

const getIsLastBarEmpty = (score: IScore) => {
    const lastBar = getLastBar(score);
    const allBarsIndexes = [0, 1, 2, 3, 4, 5].filter(n => score["bars" + (n || "")] as IBar[]);
    const isLastBarEmpty =
        allBarsIndexes
            .map(n => score["bars" + (n || "")] as IBar[])
            .filter(bars => {
                return bars.length - 1 === lastBar;
            })
            .filter(bars => {
                return (bars[lastBar]?.notes?.length || 0) > 0;
            }).length === 0;
    return isLastBarEmpty;
};

export default getIsLastBarEmpty;
